// extracted by mini-css-extract-plugin
export default {"title":"offersList_title__BSa2J","offers":"offersList_offers__PG1JZ","emptyMsg":"offersList_emptyMsg__QNhWs"};